import { queryKeys } from '@query/keys'
import { useQuery } from '@tanstack/react-query'
import React from 'react'

import { useModal } from '@context/ModalsContext'
import { useSessionLanguage } from '@context/SessionSettingsContext'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import { ClientNciPriorityDto } from '@model/ClientNciPriorityDto'
import { CreateClientDocument } from '@model/CreateClientDocuments'
import { ClientCreateNciFinalHistory } from '@model/CreateNciHistory'
import { DocumentCategoryType } from '@model/DocumentCategories'

import { Loading } from '@shared/components/Loading/Loading'
import { AlreadyUploadedModal } from '@shared/modals/AlreadyUploaded.modal'

import { DocumentInfoNonNciPageStep1Form } from './DocumentInfoNonNciPageStep1Form'

interface OuterProps {
  accountNciAvailablePriorities: ClientNciPriorityDto

  onSkip(): void

  onSkipDocuments(): void

  handleSubmitReason(reason: string): void

  handleSubmit(): void
}

export const DocumentInfoNonNciPageStep1Page: React.FC<OuterProps> = (props) => {
  const apiClient = useApiClient(ClientApiClient)
  const locale = useSessionLanguage()

  const { data: documentCategoryTypes, isLoading } = useQuery({
    queryKey: queryKeys.signup.documentTypes(DocumentCategoryType.Personal, locale),
    queryFn: () => apiClient.getDocumentCategories(DocumentCategoryType.Personal, locale),
  })

  const handleSubmit = async (
    values: ClientCreateNciFinalHistory,
    documents: CreateClientDocument[]
  ) => {
    try {
      await apiClient.uploadDocuments({ documents })
      props.handleSubmit()
    } catch (error: unknown) {
      alreadyUploadedModal.open({ message: (error as any).response?.response?.data?.code })
    }
  }

  const alreadyUploadedModal = useModal(AlreadyUploadedModal)

  return (
    <Loading isLoading={isLoading} showLoadingIcon>
      {documentCategoryTypes && (
        <DocumentInfoNonNciPageStep1Form
          {...props}
          documentCategoryTypes={documentCategoryTypes}
          handleSubmit={handleSubmit}
        />
      )}
    </Loading>
  )
}
